export const FEATURE_SEARCH_DISPLAY_DESIGNER = 'search-display-designer'

export const FEATURE_POST_REVIEW_RECOMMENDATION_MODAL = 'post-review-recommendation-toggle'

export const FEATURE_TRIAL_OFFER_ON_PRODUCTS_CARDS_NEW_CATEGORY_PAGES =
  'growaa-350-trial-offer-on-products-cards-new-category-pages'

export const FEATURE_TRIAL_OFFER_ON_PRODUCTS_CARDS_AI_CATEGORY_PAGES =
  'growaa-351-trial-offer-on-products-cards-ai-category-pages'

export const FEATURE_TRIAL_OFFER_ON_PRODUCTS_CARDS_STOCKPHOTOS_CATEGORY_PAGES =
  'growaa-351-trial-offer-on-products-cards-stockphotos-category-pages'

export const FEATURE_ENABLE_SEARCH_HOVER_ACTIONS = 'enable-search-hover-actions'

export const FEATURE_SOCIAL_POST_PROJECT_RECREATE_DATA = 'social-post-project-recreate-data'

export const FEATURE_REMOVE_CONTENT_HOMEPAGE = 'grow-2766-remove-content-homepage'
